export default {
  contact_info_se: {
    company_name: "Securdia AB",
    company_number: "559270-2087",
    company_address: "Ekbacksvägen 22\n168 69 Bromma",
    email: "support@securdia.se",
    phone: "+46 8-520 276 42",
    contact_person: "Calle Baumgarten",
    contact_email: "calle@securdia.se",
    contact_phone: "+46 72-971 95 71",
  },
  contact_info_no: {
    company_name: "Securdia AS",
    company_number: "936 332 897",
    company_address: "Hvamstubben 17\n2013 Skjetten",
    email: "kundeservice@securdia.no",
    phone: "+47 22 55 50 01",
    contact_person: "Securdia AS",
    contact_email: "kundeservice@securdia.no",
    contact_phone: "+47 22 55 50 01",
  },
};
